import { AuthService } from '../services/auth.service';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ModalService } from '../services/modal.service';
import { filter, first } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {

  constructor(
    private navCtrl: NavController,
    private authService: AuthService,
    private modalService: ModalService
  ) { }

  async canActivate(activatedRoute: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.authStatus
        .pipe(filter(status => status?.authDone))
        .pipe(first())
        .subscribe(async (status) => {
            if (!status.logged) {
              this.authService.redirectUrl = routerState.url;
              this.navCtrl.navigateForward('/home');
              if (this.authService.redirectUrl !== '/home') {
                this.modalService.createAlertModal({
                  title: 'Connectez-vous !',
                  message: 'Vous devez être connecté pour accéder à cette page. Vous allez être redirigé automatiquement.',
                  actionRequested: true,
                  actionButtonText: 'OK'
                });
              }
              resolve(false);
            } else {
              this.authService.user
                .pipe(filter(user => !!user))
                .pipe(first())
                .subscribe((user) => {
                  if (user.passwordMustBeChanged) {
                    const isCimFlow = environment.auth?.identifierType === 'numero_adherent';
                    const passwordRoute = isCimFlow ? '/onboarding/cim-password' : '/onboarding/password';
                    if (routerState.url !== passwordRoute) {
                      this.navCtrl.navigateForward(passwordRoute);
                      resolve(false);
                    } else {
                      resolve(true);
                    }
                  } else {
                    resolve(true);
                  }
                });
            }
        });
    });
  }

}
